import {isFeatureEnabled} from '@github-ui/feature-flags'
import {LabelPicker, type LabelPickerProps} from '@github-ui/item-picker-label-tsq'

import {usePreloadedLabels} from './use-preloaded-labels'

/**
 * Relay wrapper for TSQ Label Picker with preloaded data support.
 *
 * This wrapper bridges Relay GraphQL data fetching with the TSQ (TanStack Query) Label Picker.
 * It fetches label data using Relay's useClientQuery and transforms it into the format
 * expected by the TSQ component's `preloadedLabels` prop.
 *
 * The transformation converts Relay's GraphQL response into a plain object structure
 * that TSQ can consume without requiring Relay fragment processing.
 *
 * When the `cache_issue_labels` feature flag is enabled, preloaded labels are not passed
 * to the TSQ component. Instead, the TSQ picker uses IndexedDB-based caching.
 */
export function LabelPickerTsqWithRelayWrapper({owner, repo, ...rest}: LabelPickerProps) {
  const cachingEnabled = isFeatureEnabled('cache_issue_labels')
  const preloadedLabels = usePreloadedLabels(owner, repo)
  return (
    <LabelPicker {...rest} owner={owner} repo={repo} preloadedLabels={cachingEnabled ? undefined : preloadedLabels} />
  )
}
